import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export function useQrDataUrl(value: string, size = 200) {
  const [url, setUrl] = useState<string>('');
  useEffect(() => {
    let active = true;
    QRCode.toDataURL(value, { width: size, margin: 1, color: { dark: '#0a0e14', light: '#ffffff' } })
      .then((u) => active && setUrl(u))
      .catch(() => active && setUrl(''));
    return () => {
      active = false;
    };
  }, [value, size]);
  return url;
}

export function QrCode({ value, size = 200, className }: { value: string; size?: number; className?: string }) {
  const url = useQrDataUrl(value, size);
  if (!url) return <div className="animate-pulse bg-surface-2 rounded" style={{ width: size, height: size }} />;
  return <img src={url} width={size} height={size} alt={`QR ${value}`} className={className} />;
}
